<template>
    <div class="alert alert-info px-2 py-1 d-flex justify-content-between small mb-1" v-if="internacao">
        <div>
            <i class="fa-solid fa-bed mr-2"></i>
            #{{ internacao.id_internacao }}
            <span v-if="internacao.dt_alta"> | Alta: {{ $util.getFormatDate(internacao.dt_alta) }}</span>
            <span v-else-if="internacao.dt_prev_alta"> | <strong>Previsão de Alta: {{ $util.getFormatDate(internacao.dt_prev_alta) }}</strong></span>
        </div>
        <div>
            <span v-if="internacao.local" :class="internacao.id_local_momento ? 'text-muted' : ''">
                {{ internacao.local.search }}
            </span>

            <template v-if="internacao.local_momento">
                <span class="mx-2">|</span>

                <span v-if="internacao.local_momento">
                    {{ internacao.local_momento.search }}
                </span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ['internacao'], 
}
</script>
